import { render, staticRenderFns } from "./UserNewTicket.vue?vue&type=template&id=2f3ad168&scoped=true"
import script from "./UserNewTicket.vue?vue&type=script&lang=ts"
export * from "./UserNewTicket.vue?vue&type=script&lang=ts"
import style1 from "./UserNewTicket.vue?vue&type=style&index=1&id=2f3ad168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3ad168",
  null
  
)

export default component.exports